module.exports = __webpack_public_path__ + "static/img_1008-dbd3cf03eee859d1c30d1a7a2cd15e4c.webp";